import { IconProp } from '@fortawesome/fontawesome-svg-core';

const navigationItemsSu = [
  {
    key: 'archive',
    section: 'archive',
    nameTerm: 'archive',
    icon: ['fad', 'archive'] as IconProp,
    color: 'blue',
    path: '/archive',
  },
  // {
  //   key: 'templates',
  //   section: 'templates',
  //   nameTerm: 'templates',
  //   icon: ['fad', 'folder-tree'],
  //   color: 'yellow',
  //   path: '/templates',
  // },
  {
    key: 'project-builder',
    section: 'project-builder',
    nameTerm: 'project-builder',
    icon: ['fad', 'sliders-h-square'],
    color: 'blue',
    path: '/project-builder',
  },
  {
    key: 'deleted-files',
    section: 'deleted-files',
    nameTerm: 'deleted-files',
    icon: ['fad', 'trash'],
    color: 'red',
    path: '/deleted-files',
  },
  {
    key: 'search',
    section: 'project-data',
    nameTerm: 'search',
    icon: ['far', 'search'],
    color: 'darkBlue',
    path: '/search',
  },
];

export default navigationItemsSu;
